 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","alcohol":"alcohol","base":"base","boards":"boards","buildings":"buildings","contracts":"contracts","createbanner":"createbanner","crueltyboard":"crueltyboard","defense":"defense","drugs":"drugs","earlyaccess":"earlyaccess","fightboard":"fightboard","gang":"gang","gang-buildings":"gang-buildings","gang-create":"gang-create","gang-deposits":"gang-deposits","gang-diplomacy":"gang-diplomacy","gang-fights":"gang-fights","gang-settings":"gang-settings","gangjobs":"gangjobs","gangs":"gangs","getstarted":"getstarted","guides":"guides","hall-of-fame":"hall-of-fame","heistboard":"heistboard","help":"help","history":"history","home":"home","incoming":"incoming","jobboard":"jobboard","jobs":"jobs","leaderboards":"leaderboards","lotteryboard":"lotteryboard","map":"map","missions":"missions","newcontract":"newcontract","news":"news","occupy":"occupy","outgoing":"outgoing","overview":"overview","pablo":"pablo","privacy":"privacy","referral":"referral","resources":"resources","rewards":"rewards","settings":"settings","shop":"shop","simulator":"simulator","station":"station","targets":"targets","tasks":"tasks","territory":"territory","tokens":"tokens","training":"training","transport":"transport","tutorial":"tutorial","units":"units","unitsbunker":"unitsbunker","unitshelp":"unitshelp","unitssettings":"unitssettings","userhistory":"userhistory","weapons":"weapons","withdraw":"withdraw"}[chunkId]||chunkId) + "." + {"about":"355a4408","alcohol":"e1b601e3","base":"6c932ee4","boards":"0d09c65b","buildings":"f9dd178d","chunk-2d0e95df":"f4c25eb2","contracts":"f021ef0a","createbanner":"a83d3294","crueltyboard":"1503a7d6","defense":"dd3111ac","drugs":"674cada6","earlyaccess":"cd06158d","fightboard":"b0609ef1","gang":"d05c6ab4","gang-buildings":"c6526da2","gang-create":"a348b450","gang-deposits":"fa869c5f","gang-diplomacy":"c58e7282","gang-fights":"d1476d8d","gang-settings":"1311424f","gangjobs":"d1fe882c","gangs":"ffee02a3","getstarted":"e6fc5a77","guides":"152ab108","hall-of-fame":"f8456dcd","heistboard":"0a6e8be5","help":"dac0e7f0","history":"1426c08f","home":"02fdf3f7","incoming":"59e3773e","jobboard":"1b8b86a5","jobs":"8857dd61","leaderboards":"dde4942f","lotteryboard":"a6e49770","map":"01327af6","missions":"b73013b9","newcontract":"4d62e070","news":"dc474923","occupy":"057d9cfb","outgoing":"3ad571df","overview":"cb2b963f","pablo":"a4ec104e","privacy":"5c5c0228","referral":"37e3557a","resources":"859796ec","rewards":"70ad4b6c","settings":"eee8eaaa","shop":"0731b7d4","simulator":"d927a68e","station":"5df0c461","targets":"edbfd9b1","tasks":"df403033","territory":"86d135ac","tokens":"d64f34a7","training":"b03ae490","transport":"259d7ed5","tutorial":"f116d954","units":"5f922003","unitsbunker":"8d37c86e","unitshelp":"706399ec","unitssettings":"ae3dcd8e","userhistory":"0867e453","weapons":"4d09b4e3","withdraw":"b24c2156"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about":1,"base":1,"createbanner":1,"gang-deposits":1,"gang-diplomacy":1,"gang-fights":1,"getstarted":1,"guides":1,"help":1,"history":1,"home":1,"incoming":1,"missions":1,"news":1,"occupy":1,"overview":1,"referral":1,"resources":1,"simulator":1,"station":1,"tasks":1,"territory":1,"transport":1,"unitsbunker":1,"unitssettings":1,"userhistory":1,"withdraw":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","alcohol":"alcohol","base":"base","boards":"boards","buildings":"buildings","contracts":"contracts","createbanner":"createbanner","crueltyboard":"crueltyboard","defense":"defense","drugs":"drugs","earlyaccess":"earlyaccess","fightboard":"fightboard","gang":"gang","gang-buildings":"gang-buildings","gang-create":"gang-create","gang-deposits":"gang-deposits","gang-diplomacy":"gang-diplomacy","gang-fights":"gang-fights","gang-settings":"gang-settings","gangjobs":"gangjobs","gangs":"gangs","getstarted":"getstarted","guides":"guides","hall-of-fame":"hall-of-fame","heistboard":"heistboard","help":"help","history":"history","home":"home","incoming":"incoming","jobboard":"jobboard","jobs":"jobs","leaderboards":"leaderboards","lotteryboard":"lotteryboard","map":"map","missions":"missions","newcontract":"newcontract","news":"news","occupy":"occupy","outgoing":"outgoing","overview":"overview","pablo":"pablo","privacy":"privacy","referral":"referral","resources":"resources","rewards":"rewards","settings":"settings","shop":"shop","simulator":"simulator","station":"station","targets":"targets","tasks":"tasks","territory":"territory","tokens":"tokens","training":"training","transport":"transport","tutorial":"tutorial","units":"units","unitsbunker":"unitsbunker","unitshelp":"unitshelp","unitssettings":"unitssettings","userhistory":"userhistory","weapons":"weapons","withdraw":"withdraw"}[chunkId]||chunkId) + "." + {"about":"7fd0c729","alcohol":"31d6cfe0","base":"f57dd5b7","boards":"31d6cfe0","buildings":"31d6cfe0","chunk-2d0e95df":"31d6cfe0","contracts":"31d6cfe0","createbanner":"33420d78","crueltyboard":"31d6cfe0","defense":"31d6cfe0","drugs":"31d6cfe0","earlyaccess":"31d6cfe0","fightboard":"31d6cfe0","gang":"31d6cfe0","gang-buildings":"31d6cfe0","gang-create":"31d6cfe0","gang-deposits":"0f6c8af8","gang-diplomacy":"afff38a5","gang-fights":"d04e28b6","gang-settings":"31d6cfe0","gangjobs":"31d6cfe0","gangs":"31d6cfe0","getstarted":"0622557b","guides":"c5b33de9","hall-of-fame":"31d6cfe0","heistboard":"31d6cfe0","help":"ef49b8b0","history":"a91999a3","home":"baf7625b","incoming":"d04e28b6","jobboard":"31d6cfe0","jobs":"31d6cfe0","leaderboards":"31d6cfe0","lotteryboard":"31d6cfe0","map":"31d6cfe0","missions":"c50da909","newcontract":"31d6cfe0","news":"b9ae7ee6","occupy":"c397249f","outgoing":"31d6cfe0","overview":"e53d446e","pablo":"31d6cfe0","privacy":"31d6cfe0","referral":"d1bae26e","resources":"82609499","rewards":"31d6cfe0","settings":"31d6cfe0","shop":"31d6cfe0","simulator":"dafc6867","station":"d04e28b6","targets":"31d6cfe0","tasks":"1dbe7f1b","territory":"3db9a296","tokens":"31d6cfe0","training":"31d6cfe0","transport":"d04e28b6","tutorial":"31d6cfe0","units":"31d6cfe0","unitsbunker":"5edc491d","unitshelp":"31d6cfe0","unitssettings":"bd835259","userhistory":"91ecf18f","weapons":"31d6cfe0","withdraw":"642c7a92"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
